// services/captchaService.ts
import { END_POINT } from "config/environment";

export interface CaptchaVerificationResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export const verifyCaptcha = async (
  token: string,
): Promise<CaptchaVerificationResponse> => {
  try {
    const response = await fetch(`${END_POINT.BASE_URL}/verify-captcha`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        token: token,
      }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error verifying CAPTCHA:", error);
    return {
      success: false,
      error: "Failed to verify CAPTCHA",
    };
  }
};
